
/* eslint-disable */
export const comment = {
  ielts: {
    total: {
      stage1: {
        comment: [
          "在本次测评中，你的输入类测试中（听力及阅读），能够充分利用丰富的词汇量及扎实的语法基础处理大部分信息，基本能够较好地把握大段信息的主旨及细节，并按要求进行正确分析；",
          "但信息的复杂程度及话题的专业性可能会影响信息分析的正确性；",
          "在输出类测试中（写作及口语），能够充分利用已有词汇量及语法知识组织句子，能够很好地传达想要表达的信息，并多数情况做到逻辑通顺、语义正确，但语言多样性、丰富性及准确度还需进一步加强。",
        ],
      },
      stage2: {
        comment: [
          "本次测评中，你的输入类测试中（听力及阅读），能够利用已有的词汇及语法知识处理信息，多数情况能够按照题目要求抓住并正确理解细节信息，但理解主旨大意的能力较弱；",
          "在信息复杂及话题专业性强的情况下，信息处理的正确率会下降；",
          "输出类测试中（写作及口语），基本能够利用已有词汇量及语法知识组织句子，大致传达出有效信息，但受到时间或语言基础的限制，逻辑性、语义正确性、语言多样性及准确度需要进一步加强。",
        ],
      },
      stage3: {
        comment: [
          "本次测评中，你的输入类测试中（听力及阅读），处理简单且较短文本的正确率比较好，但由于词汇及语法知识相对薄弱，当篇幅加长或信息变复杂时，捕捉及理解细节信息的准确度会下降，理解主旨大意的能力偏弱；",
          "输出类测试中（写作及口语），基本能够组织句子表达含义，但词汇量有限，语法知识错误较多，会影响有效信息的表达与理解。",
        ],
      },
      stage4: {
        comment: [
          "本次测评中，由于你的词汇量有限，语法知识欠缺，听说读写各科都存在基础薄弱的问题；",
          "输入类测试中（听力及阅读），从材料中能够提取的有效信息有限，分析能力偏弱；",
          "输出类测试中（写作及口语），只能利用有限的词汇和语法知识传达部分信息，语言多样性、表达逻辑性、语义正确性等比较欠缺。",

        ],
      },
    },
    reading: {
      stage1: {
        comment: [
          "你阅读能力不错，能够处理内容较为复杂且信息量较大的文本；",
          "能够运用丰富的词汇知识、句法知识，处理通用类话题及常见题型，",
          "对于同义信息转述的识别和理解把握得也不错，分析文本的时候，能够较好地区分主旨和细节；",
          "基本能够运用略读和扫读等阅读策略，对信息进行综合分析及判断；",
          "但是遇到比较专业的话题或难度较大的题型，可能仍然会存在困难。",
        ],
        suggest: [
          "你的阅读基础不错，建议继续增加阅读量，多进行泛读，提升阅读速度以及对于整体信息的把控能力；",
          "同时，还要对难度较大的文本有选择地进行精读，提高对于细节信息的理解能力和句子的分析能力；",
          "此外，还要扩大阅读文本的多样性和专业性，增强复杂文本分析解读能力。",
        ],
      },
      stage2: {
        comment: [
          "你基本能够阅读并处理内容较复杂且信息量较大的文本；",
          "基本能够运用词汇知识、句法知识，处理通用类话题，但理解深度不够，有进步的空间，对于稍复杂的同义信息转述的识别和理解有时会存在问题；",
          "分析文本的时候，能够有效区分主旨和细节，但信息的综合分析理解上会存在一些问题，处理阅读中难度较大的题时也会存在困难。",
        ],
        suggest: [
          "你的阅读基础尚可，建议增加阅读量，重视精读，通过分析句子、细节信息来提高阅读理解能力；",
          "同时，有选择地进行泛读，泛读的文本难度不宜过大，以提升阅读速度及对于信息的整体把控能力；",
          "此外，词汇是阅读的基础，在精读、泛读过程中也要重视词汇的积累，培养在语境中背单词的意识，为阅读扫清障碍。",
        ],
      },
      stage3: {
        comment: [
          "你基本能够阅读并处理信息量较大的文本，但对于复杂信息的处理能力偏弱；",
          "能够运用已有的词汇知识、句法知识，处理通用类文章及简单题目，但处理复杂文本信息、专业类话题的能力欠缺，词汇量很多情况下会成为阅读的障碍；",
          "能够理解相对复杂的观点和论点，但只能对于文章进行大体上的理解，综合分析能力较弱。",
        ],
        suggest: [
          "你的阅读理解很多时候会受限于词汇量，所以当务之急是积累单词，夯实语法，为阅读扫清障碍；",
          "多进行精读，多分析句子，在阅读中提高细节信息的理解能力；",
          "可以对较为简单的文本进行泛读，以培养快速浏览的能力，提高阅读速度。",
        ],
      },
      stage4: {
        comment: [
          "你能够阅读比较简单、内容直白的事实类和论述类文本；",
          "能够运用词汇及部分句法知识，但理解大多局限于句子层面，仅能够理解直接表达的信息、观点及论点；",
          "基本能够从文章中提取关键信息，但词汇、语法基础是比较大的障碍，综合分析及判断的能力有限。。",
        ],
        suggest: [
          "积累单词、学习语法是当务之急，要注意将单词放在句子中进行背记，夯实基础为阅读扫清障碍；",
          "进行精读，尤其是题干中涉及的句子，是精读理解的重点；",
          "在此基础上，要训练略读、扫读的能力，以提高阅读效率；",
          "在阅读学习初期，你需要每天都坚持至少一个小时的阅读训练。",
        ],
      }, 
      stage5: {
        comment: [
          "你基本能够阅读比较简单、内容直白的事实类和论述类文本，但理解很有限；",
          "能够运用已有的词汇及部分句法知识帮助阅读，但由于词汇量比较小、基础较弱，理解句子具有局限性；",
          "大致能够理解直接表达的信息、观点及论点，但从文章中提取有效信息的能力有待加强。",
        ],
        suggest: [
          "夯实基础，多背单词，加强语法，注意将词汇及语法放在句子中进行理解；",
          "进行精读，尤其是题干中涉及的句子，是精读理解的重点；",
          "在此基础上，要训练略读、扫读的能力，逐渐培养篇章意识，以提高阅读效率；",
          "在阅读学习初期，你需要每天都坚持至少一个小时的阅读训练。",
        ],
      },
      stage6: {
        comment: [
          "你对阅读简单、直白的事实类和论述类文本的能力有限；",
          "词汇、句法知识有限，严重阻碍句子理解；",
          "理解直接表达的信息、观点及论点的能力也会受到欠缺词汇、语法知识的阻碍；",
          "由于理解的信息有限，从文章中提取关键信息的能力也有待提高。",
        ],
        suggest: [
          "夯实基础，多背单词，加强语法，注意将词汇及语法放在句子中进行理解；",
          "在积累了一定词汇量的基础上，尝试对于简单文本进行精读，重点可放在题干中涉及的句子上；",
          "在阅读学习初期，你需要每天都坚持至少1个小时的阅读单词学习和至少1个小时的精读训练，才会有比较好的学习效果。",
        ],
      },
    },
    listening: {
      stage1: {
        comment: [
          "你能处理较为复杂的音频信息，听写能力也还不错，对于填空题类型的题目正确率应该会比较高；",
          "对于同义信息转述的反应和理解把控得还不错，但是遇到比较复杂的配对题和难度较大的选择题，可能仍然会存在困难。",
        ],
        suggest: [
          "继续强化长篇幅文段的精听与听写对于把控整体信息和细节信息都很有帮助，",
          "你的基础不错，所以应该有意识地去综合运用信息预测等技巧，结合精听和泛听，继续强化听力解题的能力，提高解题的正确率。",
        ],
      },
      stage2: {
        comment: [
          "你基本能够处理较为复杂的音频信息，但是可能会存在一些问题；",
          "听写能力上基础尚可，对于填空题类的题型的正确率仍然有提升的空间；",
          "对于稍微复杂的同义信息转述和主旨信息和细节信息的把控会存在一些问题；",
          "听力中的配对题和选择题可能需要你花更多的时间来学习。 ",
        ],
        suggest: [
          "建议你加强背诵听力场景词汇，尤其从听写和词性、词义等角度，对于自己不熟悉的话题场景词汇尤其要注意；",
          "精听和听写可以从一些较长的句子开始，还是需要有意识地强化自己对于关键信息的把握和对整体信息的理解能力，需要提升对听力内容的反应和判断速度。 ",
        ],
      },
      stage3: {
        comment: [
          "你对篇幅较短的音频信息处理得还不错，但是对于稍长一些的音频信息处理起来比较吃力；",
          "听写能力还存在提升空间；",
          "能意识到对同义信息转述的把控，但是反应速度和理解都存在一定问题；",
          "主旨信息和细节信息的把控对你来说可能比较难，需要花更多时间提升。",
        ],
        suggest: [
          "建议你从词汇和简单句开始学习听力，巩固和加强词汇听写学习；",
          "从简单句开始做精听和听写，在这个基础之上，再开始强化对于复杂句中的主要信息和细节信息的反应速度和理解速度；",
          "对于信息预测等帮助提升听力理解能力之类的技巧，需要慢慢地能意识且能总结运用。 ",
        ],
      },
      stage4: {
        comment: [
          "处理一些较长的音频信息对你来说难度较大，对于篇幅较短的音频信息处理能力也一般；",
          "对听写能力、同义信息转述的反应与理解存在一定的问题，",
          "主旨信息和细节信息的把控大多数时候可能做得不太好。",
        ],
        suggest: [
          "建议你先强化听力的词汇学习，提升自己对于听词汇的反应速度，进而提升对一些短句子的反应和理解能力；",
          "在此基础之上，先学习听主旨，学习信息预判和推断，再强化听细节的能力，循序渐进提升听力学习；",
          "在听力学习初期，你可能会需要每天都坚持至少一个小时的听力训练。",
        ],
      }, 
      stage5: {
        comment: [
          "你对篇幅较短的音频信息处理能力有所欠缺；",
          "只能听懂一些片段式的琐碎信息，而且程度也有限；",
          "对于信息预判和推断、同义信息转述、主旨信息和细节信息的把控能力仍亟待提高。",
        ],
        suggest: [
          "夯实基础，加强背诵听力场景词汇，尤其是相对不熟悉的话题及学术用语；",
          "对音频内容进行精听练习，提升对于音频信息的敏感度和辨识度；",
          "在此基础之上再强化句子和篇章的听力练习；",
          "在听力学习初期，你可能会需要每天都坚持至少两个小时的听力训练才能保证学习效果。",
        ],
      },
      stage6: {
        comment: [
          "你能够听懂的语言材料非常有限，词汇量不足严重影响对于音频内容的理解；",
          "对于片段式的琐碎信息受限于认识的单词量；",
          "对于信息预判和推断、同义信息转述、主旨信息和细节信息的把控能力仍亟待提高。",
        ],
        suggest: [
          "夯实基础，加强背诵听力场景词汇。",
          "在有一定词汇量基础的情况下，尝试对音频内容进行精听练习，练习时可以每句停顿或重复，以提升对于音频信息的敏感度和辨识度。",
          "在听力学习初期，你可能会需要每天都坚持至少两个半小时的听力训练才能保证学习效果。",
        ],
      },
    },
    speaking: {
      stage1: {
        comment: [
          "你能够相对轻松的，对常见话题进行英文表达，且内容方面相对清晰，容易识别；",
          "你的词汇掌握，基本能够支撑你的口语表达，尤其是生活类话题，当讨论到比较抽象的话题时，比如社会现象，政府决策等，会有表达上的困难；",
          "语法上，能够在第三人称单数，过去时态等比较基础的方面，进行正确的口语表述，但是当遇到复杂的结构时，容易有错误，但整体不影响理解。",
        ],
        suggest: [
          "可以关注时事相关的英文报道，积累相关的表达，包括各种词汇和短语搭配，以及相对复杂的语法结构；",
          "尽量创造开口条件，将自己的积累真正开口说出来；",
          "可以试着给自己的口语答案录音，然后重听自己的答案，对照平时的积累，查漏补缺。",
        ],
      },
      stage2: {
        comment: [
          "你基本上可以简单的进行英文对话，听众也能比较容易的理解你的表达；",
          "词汇上，用词相对简单，词汇的重复使用情况比较多，碰到不熟悉的话题，会有明显的表达障碍；",
          "语法上时不时会有小错误出现，表达时简单句居多，整体不影响理解。",
        ],
        suggest: [
          "平时可以多积累话题相关的词汇以及短语，比如如何描述一个建筑物，如何描述一部科幻电影等；",
          "增强生活中常见话题的词汇和短语的量，是你最需要做的。",
        ],
      },
      stage3: {
        comment: [
          "面对常规的话题，比如音乐，电影，旅行等，你可以进行简单的表述，同时与他人进行沟通，但你所掌握的话题局限性大，很多话题是不熟悉的，所以在表述时很难深入；",
          "语法上问题稍多，通常不影响理解，但会偶尔由于句型结构的错误使用，令听众无法理解的情况。",
        ],
        suggest: [
          "要注重词汇和语法的基础，尤其是词汇；",
          "多积累词汇，可以按照话题进行积累，比如旅行，购物，上网，运动等；",
          "可以做一些跟读的训练，即按照英文原版音频，进行模仿练习，提升表达的流畅性和发音准确性，雅思听力的音频可以作为你跟读训练的素材。",
        ],
      },
      stage4: {
        comment: [
          "你可以进行简单的口语表达，但由于词汇的限制，这些表达通常局限于比较简单的话题，比如音乐，电影，或是你感兴趣的话题；",
          "你的表达通常以短语，或者不完整的句子为主；",
          "表达时，语法上的问题比较多，容易导致听众理解上的困难。",
        ],
        suggest: [
          "注重基础，多积累词汇，从各种话题词汇入手，比如书籍，电视节目，运动等；",
          "多开口，尽可能多的创造使用英文交流的环境，把自己积累的词汇用出来，逐渐适应用英文表达自己的想法，观点等；",
          "做一些简单的跟读训练，比如模仿雅思听力的音频，提升流畅性和发音的准确性。",
        ],
      },
      stage5: {
        comment: [
          "系统未检测到有效音频，请检查设备是否可以正常录音",
        ],
        suggest: [
          "系统未检测到有效音频，请检查设备是否可以正常录音。",
        ],
      }
    },
    writing: {
      stage1: {
        comment: [
          "你能够进行有效论述，所写段落中覆盖了和论点相关的内容，论据大部分是有效的；",
          "表达基本能够被读者理解，能够综合使用简单句和复杂句，文段中语法表达没有严重的失误；",
          "词汇量稍有不足，个别用词不够学术。",
        ],
        suggest: [
          "加大词汇量，多分析高分范文，多做与写作相关的翻译练习；",
          "加强语法方面的训练，尤其在使用复合句和复杂句方面，学会使用句与句之间的逻辑关系词，加强论点和论据的写作。",
        ],
      },
      stage2: {
        comment: [
          "你基本能够进行有效论述，所写段落中覆盖了和论点相关的内容，论据中一部分是有效的；",
          "基本能够综合使用简单句和复杂句；",
          "文段中的部分用词颇为简单，出现了少数的语法错误。",
        ],
        suggest: [
          "加大词汇量，多分析高分范文，多做与写作相关的翻译练习；",
          "加强语法方面的训练，尤其在使用复合句和复杂句方面，学会使用句与句之间的逻辑关系词，多练习论据的写作。",
        ],
      },
      stage3: {
        comment: [
          "你基本能够进行有效论述，所写段落中覆盖了和论点相关的内容，论据中一部分是有效的；",
          "表达基本能够被读者理解，能够使用基本的句子，但是也有很多使用问题，也极少使用复杂句；",
          "文段中词汇使用颇为简单和单一，语法出现了较多的错误。",
        ],
        suggest: [
          "加大词汇量，学会分析高分范文，多做与写作相关的翻译练习；",
          "加强语法方面的训练，夯实语法基础，尤其在使用复合句和复杂句方面，学会使用句与句之间的逻辑关系词。",
        ],
      },
      stage4: {
        comment: [
          "系统未检测到有效文本，请确认是否已作答；",
        ],
        suggest: [
          "系统未检测到有效文本，请确认是否已作答；",
        ],
      }
    },
  },
  toefl: {
    total: {
      stage1: {
        comment: [
          "在本次测验中，你表现的相对优异，尤其主旨信息的判断，可以有效的抓取材料中的主旨信息；",
          "此外，无论是在阅读科目，还是在听力科目，你都可以相对理想地处理文章的框架。",
          "但是需要留意阅读和听力中的细节信息抓取，高效地处理其中的细节内容；",
          "同时，需要更丰富的词汇和句式用于口语和写作，提升口语的流利度及写作中的句式多样性；并且需要进一步提升内容的逻辑性。",
        ],
      },
      stage2: {
        comment: [
          "在本测试中，你展现了较好的听说读写能力，已经初步掌握了托福考试的基本技能，",
          "但需要进一步提升阅读效率，关注信息之间的逻辑关联，加强信息总结能力；注意口语素材积累，丰富论述展开；",
          "不断加强对复杂听力材料的理解，关注听力材料的逻辑结构；",
          "强化写作论证，使话题发展更加详实、充分、清晰。",
        ],
      },
      stage3: {
        comment: [
          "你的阅读需要加强在基础层面训练， 比如句子层面的信息理解；",
          "在听力方面能够获取少部分的信息，但缺乏对信息的整合能力，对考点的预判能力；",
          "口语的发音表达不够清晰流畅，口语表达中的出现的语法错误较多，也不能很好的展开话题的讨论；",
          "在写作方面，你在审题、组织文章、书写表达的正确性和多样性方面都有比较大的可提升的空间。",
          "建议你从基础层面的能力开始准备，加油！",
        ],
      },
    },
    reading: {
      stage1: {
        
        comment: [
          "本次阅读测试，你的表现相对优秀；从测试结果来看，你可以在把握文章大意的同时抓取重要细节信息，托福文章理解将不会成为你阅读考试时的障碍，可以把备考重点放在题型解题技巧和话题综合训练上；",
          "日常练习中，需要进一步加强在紧凑的时间中识别出句子的重要信息的能力；同时需要强化考试中的细节把握和节奏控制。"
        ],
        suggest: [
          "参加模考，加强考试的节奏控制，提升解题速度与正确率；",
          "分析文章结构，更好的理解段落内的主旨与层次，同时把握篇章的逻辑与发展；",
          "体会篇章中的隐含细节；",
          "总结题型解题方法，弥补弱项；",
          "积累学术词汇。",
        ],
      },
      stage2: {
        
        comment: [
          "你的阅读能力有待提升；从测试结果来看，看完阅读文章掌握文章大意对你来说不是难题，但是在遇到长难句和复杂段落关系时，你可能需要反复看才能梳理清楚，这将极大的影响你的阅读速度以及做题效率；",
        ],
        suggest: [
          "针对弱势题型，进行针对性训练；",
          "积累逻辑词，正确判断上下文关系；",
          "树立篇章阅读意识，分析段落内的主旨与层次，不局限于细节理解，注重把握文章的脉络发展；",
          "总结题型解题方法，更好的掌握主旨题及篇章总结题，弥补弱项；",
          "积累学术词汇。",
        ],
      },
      stage3: {
        comment: [
          "你的阅读能力亟待提升；从测试结果来看，看懂托福阅读文章对你来说是一项挑战。",
          "你对阅读文章理解还停留在字面意思，很难在阅读过程中梳理细节信息关系，判断文章层次脉络，这会极大的限制你做题时的表现。"
        ],
        suggest: [
          "拓展词汇量；",
          "从简单的材料开始，不断加强句子精读练习，把握句子内部的语法成分和对主从句的认知，逐步过渡到托福阅读长难句的分析；",
          "加强逻辑训练，有意识地去把握句子内部逻辑；",
          "加强段落的精读训练，分析段内的主旨与层次，识别段落内部的重要细节信息，同时加强篇章层次把握的训练；",
          "了解托福各大题型解题方法，加强练习。",
        ],
      },
    },
    listening: {
      stage1: {
        comment: [
          "在本次听力测试中，你的表现相对优秀；",
          "从测试结果来看，你可以在把握音频材料大意的同时抓取重要细节信息，可以把备考重点放在题型解题技巧和话题综合训练上；",
          "日常练习中，需要进一步加强在紧凑的时间中识别出句子的重要信息的能力；",
          "同时需要强化考试中的细节把握和节奏控制。",
        ],
        suggest: [
          "参加模考，加强考试的节奏控制，提升解题速度与正确率；",
          "总结题型解题方法，弥补弱项；",
          "提升听力材料中语用信息在相关环境下的理解，例如说话者的态度表现，引用句子的作用等；",
          "分析篇章结构及考点，预测考题；",
          "积累相关的学术词汇。",
        ],
      },
      stage2: {
        comment: [
          "你的听力能力有待提升；从测试结果来看，你能够听出部分细节信息，对于篇幅较短的音频信息处理能力尚可，但遇到长音频就会手忙脚乱，无法理清音频材料的逻辑，对文章结构的把握不够准确。"
        ],
        suggest: [
          "精听长难句及段落，抓取句子主干并识别句子框架，把握段落主旨内容；",
          "积累相关的逻辑词，正确判断上下文逻辑关系；",
          "分析听力材料的层次与结构，识别重要细节信息。",
          "重点体会听力材料中的隐含信息及语境应用。",
        ],
      },
      stage3: {
        comment: [
          "你的听力能力亟待提升；从测试结果来看，对于篇幅较短音频信息处理能力一般，只能听懂一些片段式的琐碎信息，但是程度也有限，同时不能够甄别出重要细节信息。",
          "更不能够在把握整个段落的框架，这将极大影响做题时的表现。",
        ],
        suggest: [
          "拓展听力词汇，能做到听到单词迅速识别出这一单词的意思；",
          "加强句子的精听和复述练习，从理解单句开始，抓取其中的主要信息，主旨内容；",
          "识别听力材料中的逻辑词，加强信息之间逻辑关系的把握；",
          "树立结构意识，加强听力材料的层次识别与分析，且能反映在笔记中；",
          "加强对考点识别和预判的训练。",
        ],
      },
    },
    speaking: {
      stage1: {
        comment: [
          "在口语测试环节，你可以通过严密的结构和逻辑表达出自己的观点，可以把整体内容串起来，相对比较容易理解；",
          "虽然偶有思维和表达停顿，但是不太影响理解。",
        ],
        suggest: [
          "提升流利度，做到长短句结合，适当使用习惯用语；",
          "从机经中刷题，积累口语素材，注意话题的展开，强化整体思路；",
          "在逻辑方面，做更多的训练，使思维严密，思路发展有理有据；",
          "提升语音语调，使发音更地道；",
          "丰富相关词汇。",
        ],
      },
      stage2: {
        comment: [
          "在口语部分，你能表达自己的主要观点，给出观点的解释，但思路有限，不够详实，且观点间的衔接不够清晰；",
          "语言表达整体不会对理解有太大影响，但会有一些句子重复及停顿现象；",
          "句式结构相对单一，语音语调有待提升，这些问题会导致整体语意表达会有含糊。",
        ],
        suggest: [
          "每天定量练习，不断模仿语音语调；",
          "使用多样化的句式表达观点；",
          "积累口语素材，注意话题的展开，丰富内容，避免观点或信息的来回重复；",
          "加强逻辑训练，避免出现跳跃性思维或前后信息不相关的现象。",
        ],
      },
      stage3: {
        comment: [
          "在口语测试环节，你的表达不够充分，重复句子、停顿和口误等现象很明显，在谈论日常话题时，能比较自如地说话成句，进行简短的交流，",
          "能用简短的、不连贯的语句和固定模版完成答题。",
        ],
        suggest: [
          "积累和掌握更多的词汇和表达；",
          "补充语法知识，减少句式中的语法错误；",
          "尝试使用稍复杂和地道的口语表达；",
          "积累素材，形成自己在答题时的套路和方法；",
          "敢于张口，勤模仿，加强练习，提高流利度。",
        ],
      },
      stage4: {
        comment: [
          "系统未检测到有效音频，请检查设备是否可以正常录音",
        ],
        suggest: [
          "系统未检测到有效音频，请检查设备是否可以正常录音。",
        ],
      }
    },
    writing: {
      stage1: {
        comment: [
          "在写作测试中，你的表现相对优秀，写作内容观点鲜明，阐说充分，支持观点的内容有说服力，逻辑性不错；",
          "句与句连接基本比较顺畅，大部分用词贴切地道；",
          "之后的复习重点可以多从题型方面展开，掌握一些难点题型的展开思路，例如绝对词型的论证方法等。",
        ],
        suggest: [
          "在写提纲时多注意理清论点和论据间的逻辑关系，会帮助后面快速写作；",
          "句式要丰富，合理使用主动，被动，非谓语，倒装句等；",
          "注意素材的积累，尤其是事例，以避免在写作中出现“假大空”的现象。论证所用的事例既可以是自己的，也可以是名人的，但是要具体。",
        ],
      },
      stage2: {
        comment: [
          "你的写作能力有待提高；",
          "能基本围绕观点展开论述，并运用了一些简单的解释来支撑你的观点，但存在一些表达上的问题，有一些小的语法及词汇问题；",
          "对于写出相对比较复杂的句子，你会感到有些困难，行文推进过程中逻辑严谨度还需要加强。",
        ],
        suggest: [
          "理清论点和论据间的逻辑关系；",
          "努力丰富写作句式，合理使用主动，被动，非谓语，倒装句等；",
          "把握好过渡词的使用，合理使用并列，递进，因果，转折，举例等逻辑词；",
          "注意素材的积累，尤其是事例，以避免在写作中出现“假大空”的现象。论证所用的事例既可以是自己的，也可以是名人的。",
        ],
      },
      stage3: {
        comment: [
          "在本次写作测试中，你可以使用简单的语言书写段落，但是观点后的解释不够充分，思路方面的逻辑存在漏洞；",
          "英文句子中的逻辑衔接也不够严谨，要写出相对复杂且表达正确的句子会感到很吃力，这些问题导致不能恰当完整地表达出自己的观点。",
        ],
        suggest: [
          "积累足够多的单词，尤其是话题类词汇，能在写作中学以致用；",
          "平时多练习审题;",
          "理清论点和论据间的逻辑关系；",
          "句式要丰富，合理使用主动，被动，非谓语，倒装句等；",
          "多关注行文推进的逻辑，合理使用并列，递进，因果，转折，举例等逻辑词；",
          "注意素材的积累，尤其是事例，以避免在写作中出现“假大空”的现象。论证所用的事例既可以是自己的，也可以是名人的，但一定要具体。",
        ],
      },
      stage4: {
        comment: [
          "系统未检测到有效文本，请确认是否已作答；",
        ],
        suggest: [
          "系统未检测到有效文本，请确认是否已作答；",
        ],
      }
    },
  },
}

export const typeFrom = {
  'reading': '阅读',
  'speaking': '口语',
  'writing': '写作',
  'listening': '听力',
  'vocabulary': '词汇',
  'grammar': '语法',
}

export const speakingRadar1 = [
  { name: '流利与连贯' },
  { name: '话题发展' },
  { name: '语言使用' },
];

export const speakingRadar2 = [
  { name: '词汇多样性' },
  { name: '发音准确度' },
  { name: '语法准确性' },
  { name: '流利与连贯' },
];
export const writingRadar1 = [
  { name: '词汇丰富度' },
  { name: '主题把握' },
  { name: '篇章结构' },
  { name: '论证展开' },
  { name: '语法准确性' },
  { name: '句式多样性' },
];

export const writingRadar2 = [
  { name: '主题把握' },
  { name: '写作框架' },
  { name: '论点展开' },
  { name: '句式多样性' },
  { name: '词汇丰富度' },
  { name: '语法准确性' },
];

export const speakingPigaiResult1 = [
  { name: '流利与连贯', score: 0 },
  { name: '话题发展', score: 0 },
  { name: '语言使用', score: 0 },
]

export const speakingPigaiResult2 = [
  { name: '词汇多样性', score: 0 },
  { name: '语法准确性', score: 0 },
  { name: '流利与连贯', score: 0  },
]

export const writingPigaiResult1 = [
  { name: '词汇丰富度', score: 0 },
  { name: '篇章结构', score: 0  },
  { name: '论证展开', score: 0  },
  { name: '语法准确性', score: 0  },
  { name: '句式多样性', score: 0  },
]
export const writingPigaiResult2 = [
  { name: '句式多样性', score: 0  },
  { name: '词汇丰富度', score: 0  },
  { name: '语法准确性', score: 0  },
]

export const speakingForm1 = {
  'SCORE_DELIVERY': '流利与连贯',  
  'SCORE_LANGUAGE_USE': '语言使用', 
  'SCORE_TOPIC_DEVELOPMENT': '话题发展',
};
export const speakingForm2 = {
  'SCORE_DELIVERY': '流利与连贯',  
  'SCORE_LANGUAGE_USE': '语法准确性', 
  'SCORE_TOPIC_DEVELOPMENT': '词汇多样性',
}
export const writingForm = {
  'organizationScore': '篇章结构',  
  'lexicalComplexityScore': '词汇丰富度', 
  'developmentScore': '论证展开',
  'grammarScore': '语法准确性',
  'styleScore': '句式多样性',
};


// 完整版入学测评 评语

export const fullComment = {
  toefl: {
    total: {
      reading: {
        stage1 : ["阅读部分，你的表现较好，但当文字信息量大，且内容较复杂时，无法迅速找到，并理解关键信息；"],
        stage2 : ["阅读部分，你的表现较差，仅能处理文字信息少，且内容不复杂的句子；", "当信息量增大时，容易看不懂；"]
      },
      listening: {
        stage1 : ["听力部分，你的表现较好，但当音频信息量大，语速快，且内部信息逻辑较复杂时，容易被误导；"],
        stage2 : ["听力部分，你的表现较差，仅能够识别信息量少，且内容逻辑较单一的句子；", "当信息量增大时，容易听不懂；"]
      },
      speaking: {
        stage1 : ["口语部分，你的表现较好，但例子的使用还可以更有力，流利度仍有待提升；"],
        stage2 : ["口语部分，你的表现较差，仅能够给一些简短的表达，而且会出现表述不准确的现象；"]
      },
      writing: {
        stage1 : ["写作部分，你的表现较好，但逻辑方面还需要进一步提升，例子及说理可以更有力，此外复杂句的使用容易出现错误；"],
        stage2 : ["写作部分，你的表现较差，仅能够给出一些简短的句子，虽然有复杂句的运用，但错误较多。"]
      }
    },
    vocabulary: {
      stage1: {
        comment: [
          "根据测试结果，我们预测你的词汇量为2000-3800，相当于掌握了80%的高考词汇;",
          "在托福考试中，如果希望获得90分及以上的成绩，有效词汇量应该不低于8000。"
        ],
        suggest: [
          "词汇的积累是一个长期过程，建议你根据自己的备考时间，制定每天的单词学习计划。",
          "你可以从四级词汇入手，夯实词汇基础；",
          "在积累这部分单词时，不仅要记忆单词的中文释义，也要关注单词的拼写，发音与用法，为口语和写作打好基础。"
        ],
      },
      stage2: {
        comment: [
          "根据测试结果，我们预测你的词汇量为3800-4800，相当于掌握了80%的四级词汇；",
          "在托福考试中，如果希望获得90分及以上的成绩，有效词汇量应该不低于8000。"
        ],
        suggest: [
          "词汇的积累是一个长期过程，建议你根据自己的备考时间，制定每天的单词学习计划。",
          "你可以从四级词汇入手，夯实词汇基础；",
          "在积累这部分单词时，不仅要记忆单词的中文释义，也要关注单词的拼写，发音与用法，为口语和写作打好基础。"
        ],
      },
      stage3: {
        comment: [
          "根据测试结果，我们预测你的词汇量为5100-6200，相当于掌握了80%六级词汇；",
          "在托福考试中，如果希望获得90分及以上的成绩，有效词汇量应该不低于8000。"
        ],
        suggest: [
          "词汇的积累是一个长期过程，建议你根据自己的备考时间，制定每天的单词学习计划。",
          "你可以从托福词汇入手，积累词汇时，不仅要记忆单词的中文释义，还需要留意单词的发音，即能够从听力的角度识别单词，为所有科目中听力的提升做好准备；",
          "除此之外，名词，动词，形容词都需要格外留意，为冲击口语和写作高分做准备。"
        ],
      },
      stage4: {
        comment: [
          "根据测试结果，我们预测你的词汇量为6400-7500，相当于掌握了80%托福词汇；",
          "在托福考试中，如果希望获得90分及以上的成绩，有效词汇量应该不低于8000。",
        ],
        suggest: [
          "词汇的积累是一个长期过程，建议你根据自己的备考时间，制定每天的单词学习计划。",
          "你可以从托福词汇入手，积累词汇时，不仅要记忆单词的中文释义，还需要留意单词的发音，即能够从听力的角度识别单词，为所有科目中听力的提升做好准备；",
          "除此之外，名词，动词，形容词都需要格外留意，为冲击口语和写作高分做准备。"
        ],
      }, 
    },
    grammar: {
      stage1: {
        comment: [
          "根据测试结果来看，你目前的语法基础较差，仅能够针对比较简单的词性，如形容词、副词等，做出正确的判读和选择，同时在简单句的部分表现尚可；",
          "但在复杂句以及特殊句型，如虚拟、倒装等，出现的问题较多。"
        ],
        suggest: [
          "你可以从分析托福阅读中的句子入手，来练习各种句子成分和从句的识别，并逐渐分析一些长难句，从而加强你对语法知识的认知；",
          "同时，通过进行简单的中英互译，来提升语法知识的运用能力。"
        ],
      },
      stage2: {
        comment: [
          "根据测试结果来看，你目前的语法基础比较扎实，能够比较好的完成词性相关的题目，以及简单句相关的题目；",
          "但是在复杂句以及特殊句型，如虚拟、倒装等，会偶尔出现问题。"
        ],
        suggest: [
          "你可以通过分析托福阅读中的长难句来夯实语法基础；",
          "同时，进行大量的翻译和仿写练习，在练习时，尽可能去对比自己所写的句子和参考答案之间的异同，从而提升自己对语法知识的运用能力。"
        ],
      }
    },
    reading: {
      '句子信息理解' :  {
        comment: [
          '根据测试结果，你最需要提升的阅读能力是句子信息理解；',
          '这项能力是指：你是否可以快速识别一个句子的主要信息，包括成分划分，分析从句关系，抓取句子主干及重要信息的能力；',
          '本项能力非常基础也非常关键，如果该项能力较弱，会导致你无法准确理解关键句子的含义，从而无法找到正确答案。'
        ],
        suggest: [
          '及时补充语法知识，扩充必要词汇；',
          '进行大量的长难句分析，以此提升长难句分析的速度和准确度。'
        ],
      },
      '细节事实理解': {
        comment: [
         '根据测试结果，你最需要提升的阅读能力是重要细节事实理解；',
         '每个句子都有自己着重想要表达的含义，尤其是在有出题点的句子中；',
         '本项能力覆盖了多种题型，比如：事实信息题，否定事实信息题，推断题，修辞目的题等。',
         '这类题型，都需要对题干及篇章中的重要句子进行要点及细节的分析理解。',
         '需要你能找到关键词，并进行句子分析，了解句子中直接或间接的含义；',
         '如果本项能力较弱，在理解句子的核心含义时你可能会有一些问题，同时，某些题型的处理可能也存在短板。'
        ],
        suggest: [
          '解题过程中，对上述4种题型的题干进行关键词分析，然后通过速读或略读的方式，进行浏览，找到定位句，最后分析该定位句，找到句子的核心含义。',
          '不断重复该过程，多加体会句子分析的过程。'
        ],
      },
      '段落主旨与层次分析': {
        comment: [
          '根据测试结果，你最需要提升的阅读能力是段落中主旨与层次的分析；',
          '这项能力是指：一个段落会包含0-2个主旨。',
          '需要我们先通读，然后分析段落中的主旨位置，及细节是如何解释主旨的。',
          '比较简单的段落，主旨和层次都比较明显且清晰。难的段落中，主旨及层次都需要自己分析之后得出；',
          '如果该项能力较弱，在理解段落的基本含义上可能会存在困难，同时修辞目的题上也会存在短板。'
        ],
        suggest: [
          '可以利用阅读真题，针对性的进行段落的分析的训练，找明段落主旨的位置及细节是如何解释，描述主旨的；',
          '同时，集中完成修辞目的的题目，体会找主旨，分析层次的含义及做法，不断总结。'
        ],
      },
      '隐含信息推断': {
        comment: [
          '根据测试结果，你最需要提升的阅读能力是隐含信息推断；',
          '这项能力是指：能否通过某些句子的字面含义，洞察其背后的信息。',
          '隐含信息虽然不是字面意思，但也不需要过分推测；',
          '如果本项能力较弱，在理解句子的核心含义时你可能会有一些问题，同时，某些题型的处理可能也存在短板。'
        ],
        suggest: [
          '集中完成推断题的题目，体会信息之间的关系并体会其推断的过程，也不要“过度推断”;',
          '多总结，多积累。'
        ],
      },
      '段间结构分析': {
        comment: [
          '根据测试结果，你最需要提升的阅读能力是段间结构分析；',
          '段落间存在一定的关系，比如并列，转折，递进，例证等。',
          '需要你在分析完段落主旨的前提下，体会多个段落间是如何连接起来，完成作者的写作意图的。',
          '如果该项能力较弱，在篇章信息的理解上可能存在困难。'
        ],
        suggest: [
          '解题过程中，对上述4种题型的题干进行关键词分析，然后通过速读或略读的方式，进行浏览，找到定位句，最后分析该定位句，找到句子的核心含义。',
          '不断重复该过程，多加体会句子分析的过程。'
        ],
      },
      '概要与分类信息': {
        comment: [
          '根据测试结果，你最需要提升的阅读能力是概要与分类信息；',
          '该项能力是指：我们需要从宏观上把握文章的写作意图。',
          '在标题下，一共有几个重要的观点来支持。',
          '同时，还涉及段落中细节的描述与分类，比如提及的两个概念或名词，我们需要分析1-2个段落中的细节，是如何进行分别的描述的。',
          '两个类别的细节通常是穿插描述的，你需要通过阅读与分析，进行分类。',
          '如果该项能力较弱，你在最后的要点总结题或表格题中可能存在一定困难。'
        ],
        suggest: [
          '了解题型特征的基础上，可以从文章话题的角度上，有意识的进行段落或篇章的分析。'
        ],
      },
      '语境中的词汇':  {
        comment: [
          '根据测试结果，你最需要提升的阅读能力是语境中的词汇；',
          '这项能力是指：能否正确识别某个语境下，指定单词的含义；',
          '词汇题的分值占据阅读总分值的四分之一左右，如果该项能力较弱，将直接影响你的阅读分数。'
        ],
        suggest: [
          '特定语境中词汇的理解，也是建立在语境的理解基础之上，即建立在词汇量的基础之上；',
          '你可以制定词汇背诵计划，原则是“快速多遍”，即提升见到该词汇的频率。'
        ],
      },
      '指代关系':  {
        comment: [
          '根据测试结果，你最需要提升的阅读能力是指代关系；',
          '英文中常常使用相关的指代来避免重复，这项能力是指：在阅读的过程中，你是否可以凭借相关的代词，从句连词，名词单复数等语法知识，正确理解前后句相同内容的指代含义；',
          '如果该项能力较弱，会导致你无法理解，阅读中前后信息是如何衔接的，有哪种逻辑关系在其中，并导致你在指代题和句子插入题中表现较差，正确率低。'
        ],
        suggest: [
          '利用托福阅读真题，分析出现在文章中的各种代词，比如人称代词、指示代词等；',
          '涉及从句的，要分析从句连接词是否具有指代关系，指代了什么信息。'
        ],
      },
    },
    listening: {
      '细节与事实把握': {
        comment: [
          '根据测试结果，你最需要提升的听力能力是细节与事实把握；',
          '该项能力是指：听力材料中细节的作用是展开和支持，它的意义是依附于上下文语境存在的，或是对概念的解释和说明，或是具体事例的补充。',
          "我们需要在听力的过程中，依据并列、转折、因果、举例、解释等逻辑关系，亦或是教授强调的重点，如interesting、 don't forget等，来判断考点并能正确完成细节题的能力；",
          '如果该项能力较差，你听力材料的理解上，可能存在很大的问题。',
          '除此之外，细节题在整个听力考试中占比非常大，该能力弱，也意味着你的听力总分会偏低。'
        ],
        suggest: [
          '进行精听练习。',
          '不单要了解每句话的含义，还需要理解其中某些逻辑词真正含义，并能在逻辑词的位置尝试预测题目。'
        ],
      },
      '主旨信息把握': {
        comment: [
          '根据测试结果，你最需要提升的听力能力是主旨信息把握；',
          '该项能力是指：在听力的过程中，能否明确了解对话双方的讨论目的，以及了解对话或讲座的主旨大意。',
          '主旨大意有时很直接，有时又很含蓄；',
          '如果本项能力较弱，你可能在听力材料的主旨中存在一定问题，同时主旨题的正确率也会偏低。'
        ],
        suggest: [
          '精听训练。',
          '听力材料中首先要听准开头，特别是开头句型，之后找出对话目的。',
          '同时，对讲座中Today we will talk about… Today we will discuss… Today we will look at… Today we will tell… 亦或是about之后的内容有清晰的洞察。'
        ],
      },
      '推断能力题': {
        comment: [
          '根据测试结果，你最需要提升的听力能力是推断能力；',
          '推断能力主要考察你对文章中一个观点或立场的理解程度，而这种观点或立场是作者在文章中强烈暗示但并没有明确阐明的。',
          '你听到的句子并不只是停留于表面意思，正确答案通常不是原文中直接提到的内容，需要你通过一定的对比或假设，进行分析之后得出的结论；',
          '如果该项能力较弱，你的听力篇章理解可能会存在问题，且在推断题目上存在一定的短板。'
        ],
        suggest: [
         '进行精听练习。',
         '着重理解其中某些逻辑词真正含义以及其暗示含义。'
        ],
      },
      '结构分析': {
        comment: [
          '根据测试结果，你最需要提升的听力能力是结构分析；',
          '该项能力是指：你需要了解一个段落在整体篇章中所担当的角色，所起到的作用。',
          '比较常见的包括：说话者会向学生提问以激发他们的兴趣，有时说话者会举一些特定的例子；',
          '出现新的概念或者术语的时候，说话者会以另一种简单的方式解释或者说明等，这时需要我们了解例子及解释的角色或作用；',
          '如果该项能力较弱，你在听力篇章理解可能会存在问题，且在组织结构题目上存在一定的短板。'
        ],
        suggest: [
          '进行精听训练的同时，了解篇章的顺序，时间等叙述方式，也需要了解局部下定义，举例，因果，比较等逻辑。'
        ],
      },
      '说话者态度识别': {
        comment: [
          '根据测试结果，你最需要提升的听力能力是态度题及态度分析；',
          '该项能力是指：需要从听力过程中理解说话者的感受，是支持还是反对，亦或是积极的还是消极的，传达的是快乐还是悲伤，亦或是充满了激情还是厌倦，表达出了肯定的态度或者是否定的态度,或是中立的态度。',
          '这种能力的难点在于，说话人会使用反语，包括强调已提出的要点、营造幽默气氛以引起听众共鸣，或者以简洁的方式表示不赞成；',
          '如果该项能力表现较弱，你可能不能理解听力材料中说话者的真正含义，并在态度题上存在一定困难。'
        ],
        suggest: [
          '进行精听练习。',
          '不单要了解每句话的含义，还需要理解其中某些语气词，副词的真正含义。'
        ],
      },
      '重听题': {
        comment: [
          '根据测试结果，你最需要提升的听力能力是复听能力；',
          '该项能力是指：在听力过程中，你需要把握说话人的语气。',
          '重听题选取的情况大致可以分布在以下几处：',
          '1.说话人语气语调加强的时候',
          '2.有人提问的时候',
          '3.文章结构转接处；',
          '如果该项能力较弱，你对说话人的态度表述可能有一定的问题，同时每篇篇章都有的重听题也会存在一定困难。'
        ],
        suggest: [
          '进行精听训练的同时，对说话人语气特别加强的位置格外注意，听出说话人的“言外之意，玄外之音“；',
          '此外，重听题的选项大多是进行同意转换或引申之后的内容，需要大家对同意替换有基本的了解，平时需要积累篇章与选项中的同义替换词语。'
        ],
      }
    },
    speaking: {
      '流利与连贯': {
        comment: [
          '根据测试结果，你最需要提升的口语能力是流利与连贯；',
          '该项能力是指：你的口语表达是否清晰、流畅，语速是否适中，发音是否准确等；',
          '如果该项能力较弱，在规定的时间内，你传达的内容会比较少，而且表述不清，产生理解障碍。'
        ],
        suggest: [
          '进行跟读训练，模仿听力材料的语音语调；',
          '跟读之前，一定要认真分析听力中的发音，然后再去模仿，否则可能会导致你的模仿是无效的。'
        ],
      },
      '话题发展': {
        comment: [
          '根据测试结果，你最需要提升的口语能力是话题发展；',
          '该项能力是指：你能否比较全面的回答问题，并保持答案中观点的一致性；',
          '如果该项能力较弱，可能会导致你的答案中信息之间逻辑性差，以及存在偏题，甚至跑题的风险。'
        ],
        suggest: [
          '平时积累相关的素材，思考可以使用的场景；',
          '练习时，要进行口语录音，保证可以在规定的时间内完成口语表达，同时去检查自己的口语答案，看看是否良好的展开了你的观点，并对比参考答案，修正自己的答题思路。'
        ],
      },
      '语言使用': {
        comment: [
          '根据测试结果，你最需要提升的口语能力是语言使用；',
          '该项能力是指：你的口语是否可以熟练使用基础和复杂的语言结构，并且使用适合的词汇；',
          '如果该项能力较弱，会导致你在传递信息时出现较大偏差，比如错误的使用词汇，严重的语法错误，这些都将较大的理解障碍。'
        ],
        suggest: [
          '注重夯实词汇和语法基础，平时练习时，一定要把自己的答案录下来，然后去听自己的答案，将其中不合适的词汇，和语法错误，找出来，并进行修改，然后重新录制答案。'
        ],
      },
      '阅读与听力语料分析': {
        comment: [
          '根据测试结果，你最需要提升的口语能力是阅读与听力语料分析；',
          '该项能力是指：综合口语前的准备工作，需要你可以快速的分析出阅读和听力材料的主旨大意，且有着准确的联系；',
          '如果该项能力较差，则直接影响综合口语的表达和分数。'
        ],
        suggest: [
          '在规定时间内，分析阅读和听力材料的主旨，并学会做笔记。',
          '其中涉及速读能力，精听等；',
          '综合口语中的听力材料，特别适合听力不太好的学生，最开始可以利用本部分材料进行精听训练。'
        ],
      },
    },
    writing: {
      '篇章结构': {
        comment: [
          '根据测试结果，你最需要提升的写作能力是篇章结构；',
          '该项能力是指：你能否在规定时间内，将文章有逻辑得组织出来。',
          '文章架构，包括开头段，中间段，结尾段的布局。',
          '其中具体的涉及逻辑词，中心句，支持句等细节信息；',
          '如果该项能力较弱，你的作文可能会比较“散”，逻辑不够清晰。'
        ],
        suggest: [
          '写作训练中，需要尤其注意中间段的写法，每个段落都需要有主题句，积累一些常用的段落展开方法，比如举例法、比较法、因果法等，此外，必要的段间逻辑也需要积累，如何正确的使用并列，转折，因果等段间逻辑。'
        ],
      },
      '主题把握': {
        comment: [
          '根据测试结果，你最需要提升的写作能力是主题把握；',
          '该项能力是指：让自己的文章表现出强烈的主题思想，其中不仅包含主要论点，还包括次要论点的表述及例子的使用。',
          '所有论点及例子，都需要围绕一个主题，并能够充分说明；',
          '如果该项能力较弱，你的“例证”部分可能无法良好支撑论点，且作文很可能会跑题。'
        ],
        suggest: [
          '拿到题目之后，利用写作思路，进行提纲的快速头脑风暴；',
          '平时写作的过程，也需要留意这一步骤。',
          '每个分论点，是否可以从正面或背面印证观点；',
          '除此之外，还需要积累一定的素材，使例子使用充分、有力。'
        ],
      },
      '论证展开': {
        comment: [
          '根据测试结果，你最需要提升的写作能力是论证展开；',
          '主体段的论证与展开既是考官评分中的一项重要依据，该项能力是指：你能否确切地陈述观点，并能清晰地将其展开。',
          '官方明确表示论证需要使用以下论证手法：解释、例证及细节；',
          '如果该项能力较弱，你的作文可能没有具体的内容支持，反复的说“车轱辘话”。'
        ],
        suggest: [
          '写作训练中，每个段落都可以写一个主题句，然后将其展开；',
          '可以去积累一些常用的段落展开方法，比如举例法、比较法、因果法等，此外，从实事，新闻，或者亲身实例中积累必要的素材作为内容支持。'
        ],
      },
      '语法准确性': {
        comment: [
          '根据测试结果，你最需要提升的写作能力是语法准确性；',
          '该项能力是指：你的写作是否可以准确，熟练使用基础和复杂的语言结构；',
          '如果该项能力较弱，你的写作可能会比较简单，或是语法错误较多，导致理解困难。'
        ],
        suggest: [
          '可以做一些句子的翻译练习，从简单句开始，并对照答案不断修正自己的句子；',
          '也可以进行仿写的练习，甚至背诵一些句子；',
          '练习时，要注重语法的准确性，以保证信息的准确传递。'
        ],
      },
      '阅读与听力语料分析': {
        comment: [
          '根据测试结果，你最需要提升的写作能力是阅读与听力语料分析；',
          '该项能力是指：综合写作前的准备工作，需要你可以快速的分析出阅读和听力材料的主旨大意，且有着准确的联系；',
          '如果该项能力较差，则直接影响综合写作的表达和分数。'
        ],
        suggest: [
          '在规定时间内，分析阅读和听力材料的主旨，并学会做笔记。',
         ' 其中涉及速读能力，精听等；',
          '综合写作中的听力材料，特别适合听力不太好的学生，最开始可以利用本部分材料进行精听训练。'
        ],
      },
      '细节转述': {
        comment: [
          '根据测试结果，你最需要提升的写作能力是细节转述；',
          '综合写作比较注重你对于阅读和听力文章的总结和阐释，但是，我们又不能完全照抄其中的原文。',
          '所以，在这个过程中，概括能力和转述能力成为了综合写作的两大核心能力；',
          '如果该项能力较差，则直接影响综合写作的表达和分数。'
        ],
        suggest: [
          '做好细节转述，一大关键为做好同意转换，需要你整理常见的同义表达，比如单词，短语等，并进行积累。'
        ],
      },
      '句式多样性': {
        comment: [
          '根据测试结果，你最需要提升的写作能力是句式多样性；',
          '该项能力是指：你的写作是否可以熟练运用基础和复杂的语言结构，且多样性的句子结构和样式使作文更加生动、自然；',
          '如果该项能力较弱，你的写作可能会比较简单，单调，与别人的作文千篇一律。'
        ],
        suggest: [
          '写作训练中，可以有意识的去交替使用简单句，并列句和复杂句；',
          '灵活使用从句和非谓语，使表达更为准确，凝练。'
        ],
      },
      '词汇丰富度': {
        comment: [
          '根据测试结果，你最需要提升的写作能力是词汇丰富度；',
          '该项能力是指：你的写作是否可以熟练使用高级词汇。',
          '并不是全篇华丽辞藻就会得分更高，但是你需要避免简单且基础的词汇，选择更为地道的词汇表达；',
          '如果该项能力较弱，你的写作可能会比较简单，单调。'
        ],
        suggest: [
          '注意积累词汇的积累，尤其一些近义词；',
          '同时注重单词的拼写，以提升写作时词汇拼写的准确度和写作速度。'
        ],
      },
    }
  },
  ielts: {
    total: {
      reading: {
        stage1 : ["阅读部分，你的表现较好，但当文字信息量大，且内容较复杂时，无法迅速找到，并理解关键信息；"],
        stage2 : ["阅读部分，你的表现较差，仅能处理文字信息少，且内容不复杂的句子；", "当信息量增大时，容易看不懂；"]
      },
      listening: {
        stage1 : ["听力部分，你的表现较好，但当音频信息量大，语速快，且内部信息逻辑较复杂时，容易被误导；"],
        stage2 : ["听力部分，你的表现较差，仅能够识别信息量少，且内容逻辑较单一的句子；", "当信息量增大时，容易听不懂；"]
      },
      speaking: {
        stage1 : ["口语部分，你的表现较好，但当你遇到不熟悉的话题时，表达上容易出现不准确，不流畅的问题；"],
        stage2 : ["口语部分，你的表现较差，仅能够给一些简短的表达，而且会出现表述不准确的现象；"]
      },
      writing: {
        stage1 : ["写作部分，你的表现较好，但句式的多样性较差，且复杂句的使用容易出现错误；"],
        stage2 : ["写作部分，你的表现较差，仅能够给出一些简短的句子，虽然有复杂句的运用，但错误较多。"]
      }
    },
    vocabulary: {
      stage1: {
        comment: [
          "根据测试结果，我们预测你的词汇量为2000-3800，相当于掌握了80%的高考词汇。",
          "在雅思考试中，如果希望获得6.5分及以上的成绩，有效词汇量应该不低于8000。"
        ],
        suggest: [
          "词汇的积累是一个长期过程，建议你根据自己的备考时间，制定每天的单词学习计划。",
          "你可以从四级词汇入手，夯实词汇基础；",
          "在积累这部分单词时，不仅要记忆单词的中文释义，也要关注单词的拼写，发音与用法，为口语和写作打好基础。"
        ],
      },
      stage2: {
        comment: [
          "根据测试结果，我们预测你的词汇量为3800-4800，相当于掌握了80%的四级词汇。",
          "在雅思考试中，如果希望获得6.5分及以上的成绩，有效词汇量应该不低于8000。"
        ],
        suggest: [
          "词汇的积累是一个长期过程，建议你根据自己的备考时间，制定每天的单词学习计划。",
          "你可以从四级词汇入手，夯实词汇基础；",
          "在积累这部分单词时，不仅要记忆单词的中文释义，也要关注单词的拼写，发音与用法，为口语和写作打好基础。"
        ],
      },
      stage3: {
        comment: [
          "根据测试结果，我们预测你的词汇量为5100-6200，相当于掌握了80%六级词汇。",
          "在雅思考试中，如果希望获得6.5分及以上的成绩，有效词汇量应该不低于8000。"
        ],
        suggest: [
          "词汇的积累是一个长期过程，建议你根据自己的备考时间，制定每天的单词学习计划。",
          "你可以从雅思词汇入手，积累词汇时，不仅要记忆单词的中文释义，也注重近义词的总结和积累，在雅思考试中，听说读写四个科目，均涉及到词汇的同义替换考察。"
        ],
      },
      stage4: {
        comment: [
          "根据测试结果，我们预测你的词汇量为6400-7500，相当于掌握了80%雅思词汇。",
          "在雅思考试中，如果希望获得6.5分及以上的成绩，有效词汇量应该不低于8000。",
        ],
        suggest: [
          "词汇的积累是一个长期过程，建议你根据自己的备考时间，制定每天的单词学习计划。",
          "你可以从雅思词汇入手，积累词汇时，不仅要记忆单词的中文释义，也注重近义词的总结和积累，在雅思考试中，听说读写四个科目，均涉及到词汇的同义替换考察。"
        ],
      }, 
    },
    grammar: {
      stage1: {
        comment: [
          "根据测试结果来看，你目前的语法基础较差，仅能够针对比较简单的词性，如形容词、副词等，做出正确的判读和选择，同时在简单句的部分表现尚可；",
          "但在复杂句以及特殊句型，如虚拟、倒装等，出现的问题较多。"
        ],
        suggest: [
          "你可以从分析雅思阅读中的句子入手，来练习各种句子成分和从句的识别，并逐渐分析一些长难句，从而加强你对语法知识的认知。",
          "同时，通过进行简单的中译英，来提升语法知识的运用能力。"
        ],
      },
      stage2: {
        comment: [
          "根据测试结果来看，你目前的语法基础比较扎实，能够比较好的完成词性相关的题目，以及简单句相关的题目；",
          "但是在复杂句以及特殊句型，如虚拟、倒装等，会偶尔出现问题。"
        ],
        suggest: [
          "你可以通过分析雅思阅读中的长难句来夯实语法基础；",
          "同时，进行大量的翻译和仿写练习，在练习时，尽可能去对比自己所写的句子和参考答案之间的异同，从而提升自己对语法知识的运用能力。"
        ],
      }
    },
    reading: {
      '细节信息把握' :  {
        comment: [
          '根据测试结果，你最需要提升的阅读能力是细节信息把握；',
          '这项能力是指：你能否将文章中的信息进行有效的理解，而不是单纯停留在文字表面的含义上；',
          '信息之间通常有一定的逻辑关系，如并列，因果，转折，举例等，把相关信息进行整体的理解，是找到正确答案的前提；如果该项能力较弱，会导致你看似读懂了文章，但是做题却错误频出，影响分数。'
        ],
        suggest: [
          '利用剑桥雅思阅读真题中的判断题、填空题等细节题，分析文章信息之间的关系，以及这些信息和题目对应关系。'
        ],
      },
      '同义信息转换': {
        comment: [
         '根据测试结果，你最需要提升的阅读能力是同义信息转换；',
         '这项能力是指：你能否在做题时有效识别出题干和原文含义相同或相近、但用词或句式结构不一致的表达。',
         '同义替换贯穿雅思阅读的所有题型；',
         '如果该项能力较弱，会导致你无法找到一些题目在原文的位置，造成定位困难；',
         '同时，很可能因为同义替换无法识别，导致句子和题干理解不透彻，进而做不对题，影响你的阅读分数。'
        ],
        suggest: [
          '根据剑桥真题中的题干及原文，在做题之后整理出现的同义表达，比如单词、短语等，或者直接利用雅思阅读同义替换的资料，进行积累。'
        ],
      },
      '主旨把握': {
        comment: [
          '根据测试结果，你最需要提升的阅读能力是主旨把握；',
          '这项能力是指，对于文章的段落或篇章进行整体理解，忽略细节信息，从宏观上把握段落大意或篇章大意。',
          '在雅思阅读考试中，会有一部分专门考查主旨大意的题型；',
          '如果该项能力较弱，将直接导致这类题型的正确率下降。'
        ],
        suggest: [
          '以剑桥雅思阅读真题为素材，读每篇文章的段落之后，对段落大意进行概括总结，在整篇文章都读完之后，对文章大意进行总结，以提高概括和整体把握的能力。'
        ],
      },
      '句子分析': {
        comment: [
          '根据测试结果，你最需要提升的阅读能力是句子分析；',
          '这项能力是指：你能否有效理解文章中重点句子的语法结构及其含义；',
          '如果该项能力较弱，会导致你无法正确或者迅速理解句子，无法根据文章中的句子来找到正确答案，直接导致分数下降。',
        ],
        suggest: [
          '可以利用剑桥雅思阅读真题，进行句子分析练习;',
          '句子的语法结构要分析到位，例如句子成分及其作用等，并且把核心的词汇都掌握，把不熟悉的词汇积累下来。'
        ],
      },
      '信息定位': {
        comment: [
          '根据测试结果，你最需要提升的阅读能力是信息定位；',
          '这项能力是指：你是否能在有限的时间内，快速浏览文本，找到特定信息的位置；',
          '如果该项能力较弱，会导致你无法快速准确找到细节题在文章中的位置，进而降低做题速度和效率，导致你在规定的时间内无法完成题目，影响你的阅读分数。'
        ],
        suggest: [
          '以剑桥雅思阅读真题为素材，训练自己快速浏览文章、寻找具有特定属性的词或表达，如人名、地名、数字等，以提高你的信息定位能力。'
        ],
      }
    },
    listening: {
      '细节信息判断': {
        comment: [
          '根据测试结果，你最需要提升的听力能力是细节信息判断；',
          '这项能力是指：能否根据题目，找到音频中对应的信息，并写出（选择）正确答案。',
          "雅思听力中大部分题目，主要考察的就是这项能力，这类题目的设置通常是针对具体的，细节化的信息。 don't forget等，来判断考点并能正确完成细节题的能力；",
        ],
        suggest: [
          '可以利用雅思听力真题，采用精听的方式来训练，即：反复听一段音频，记录下自己没有听懂的部分，对照原文，查看没有听懂的原因，解决掉这些问题之后，重新听这段音频，保证自己最后听懂音频的每一个部分。'
        ],
      },
      '单词听写': {
        comment: [
          '根据测试结果，你最需要提升的听力能力是单词听写；',
          '这项能力是指：能否根据音频，正确的拼写出题目所需要的单词或词组；',
          '如果该项能力较弱，导致即便听懂了音频，听到了答案，但依然无法得分的情况，因为拼写错误会被直接判定为答案错误。'
        ],
        suggest: [
          '加强单词的拼写训练，可以将雅思听力真题中，自己听得懂但是拼写不出来的单词整理出来，并进行反复的拼写训练，直到拼写该单词时无需思考，一气呵成。'
        ],
      },
      '同义信息转换': {
        comment: [
          '根据测试结果，你最需要提升的听力能力是同义信息转换；',
          '这项能力是指：能否识别题目和听力原文中含义一致但用词，或句型结构上不一致的表达，最常见的就是单词或短语的同义转述。',
          '同义替换会出现在听力的各种题目中，尤其是信息匹配类的题目中，所以该项能力的掌握程度，直接决定了你听力成绩的高低。'
        ],
        suggest: [
         '根据雅思听力的音频原文和题目，整理常见的同义表达，比如单词，短语等，或者直接找相关的雅思听力同义替换的资料，进行积累。'
        ],
      },
      '信息预测': {
        comment: [
          '根据测试结果，你最需要提升的听力能力是信息预测；',
          '这项能力是指：针对具体的题干信息，通过分析空格的前后内容来预测答案的词性，甚至是答案的大致范围，比如预测答案可能是一个名字，或者是数字等。',
          '良好的预测能力可以让你在听音频时有所侧重，让你比较轻松的在音频中找到答案的位置。'
        ],
        suggest: [
          '可以利用雅思听力真题，分析填空类题目，认真审题，预测答案可能出现的形式，去猜测答案，然后根据原文进行对照，检测自己的预测是否准确。',
          '通过类似这种针对性的训练，可以有效提升你对信息预测的意识和准确度。'
        ],
      },
      '主旨信息判断': {
        comment: [
          '根据测试结果，你最需要提升的听力能力是主旨信息判断；',
          '这项能力是指：能否把握音频的主旨方向，并区分不同的信息，找到解答问题所需要的信息；',
          '雅思听力中的信息量通常较大，尤其是靠后的一些题目，如果主旨信息判断能力较差，将直接导致提取到的听力信息混乱，虽然听懂了只言片语，但无法很好的完成题目。'
        ],
        suggest: [
          '可以利用雅思听力真题进行训练，听完一段音频之后，试着将你听到的信息进行梳理，得到了整体信息的大致框架后，对比原文，检查自己归纳总结时所犯的错误。'
        ],
      }
    },
    speaking: {
      '流利与连贯': {
        comment: [
          '根据测试结果，你最需要提升的口语能力是流利与连贯；',
          '这项能力是指：你在表达过程中是否流畅，断句是否自然，你所表达的信息之间，逻辑是否通顺；',
          '如果该项能力较弱，会导致你传递的信息较少，分数必然会降低；',
          '大量的跟读练习，可以有效提升表达的流畅性，并能学习到如何表述信息，来增强逻辑性。'
        ],
        suggest: [
          '进行跟读练习，模仿雅思听力中比较简单的音频。',
          '跟读之前，一定要认真分析听力中的发音，然后再去模仿，否则可能会导致你的模仿是无效的。'
        ],
      },
      '词汇多样性': {
        comment: [
          '根据测试结果，你最需要提升的口语能力是词汇多样性；',
          '这项能力是指：针对不同的口语话题，你是否有足够的词汇量来支撑自己的表达，是否能够选使用不同的词汇来丰富自己的表达。',
          '词汇量不足，会导致你在表达时，无法准确的传递信息；',
          '词汇的错误使用，会直接导致听众无法理解你的表达。'
        ],
        suggest: [
          '积累与雅思口语考试相关的话题词汇，比如描述人物类的词汇，外貌、性格等，再比如休闲娱乐类词汇，户外运动，旅行等；',
          '积累相关词汇表达时，一定要落实到口语表达上，可以将素材朗读出来，来提升口语能力。'
        ],
      },
      '语法准确性': {
        comment: [
          '根据测试结果，你最需要提升的口语能力是语法准确性；',
          '这项能力是指：在口语表达中，能否正确使用语法，比如时态，主谓一致等，以及使用语法时的多样性，比如灵活使用不同的句型结构来传递信息；',
          '如果语法能力较弱，很可能会导致听众错误理解你的表达，比如时态的错误使用，会导致听众无法判断该动作所发生的具体时间，从而带来一系列信息的时间逻辑问题。 '
        ],
        suggest: [
          '在进行口语练习时，要给自己录音，然后重听自己的答案，去分析其中的语法错误，并在以后的练习中关注这些语法点，并持续录音。',
          '经过一段时间的比对分析之后，口语语法问题通常会有所改善。'
        ],
      },
      '发音准确度': {
        comment: [
          '根据测试结果，你最需要提升的口语能力是发音准确度；',
          '这项能力是指：在口语表达中，单词的发音是否准确，是否体体现了英文中特有的发音现象，如连读，爆破等，以及语调是否自然等。',
          '语音是你所有表达的载体；',
          '如果该项能力较弱，会直接导致听众错误理解你的表达，甚至无法理解你的表达。'
        ],
        suggest: [
          '在积累词汇或者短语时，遇到拿不准的发音，一定要通过有声词典来进行确认，不能主观猜测其发音；',
          '在进行口语练习时，要给自己录音，找身边发音不错的同学或者老师，帮助你纠正发音，对于不准确的发音，要进行针对性的跟读和模仿练习。'
        ],
      },
    },
    writing: {
      '主题把握': {
        comment: [
          '根据测试结果，你最需要提升的写作能力是主题把握；',
          '这项能力是指：在拿到一个议论文题目之后，能否进行扣题的论证展开；',
          '如果主题把握能力较差，将会直接导致作文偏题，甚至跑题，从而影响写作分数。'
        ],
        suggest: [
          '利用雅思写作真题和范文，去认真分析每一个题目，并写下自己的思路和框架，然后和范文进行比较，并根据范文，来不断增强自己的主题把握能力。'
        ],
      },
      '语法准确性': {
        comment: [
          '根据测试结果，你最需要提升的写作能力是语法准确性；',
          '这项能力是指：能否正确的运用语法知识，写出完整的英语句子，例如：主谓一致、单复数等方面基本做到没有纰漏。',
          '写作中的语法错误会影响信息传递的准确性，导致某些表达无法被考官理解，从而影响写作分数。'
        ],
        suggest: [
          '注重语法能力的夯实和提升，尤其注重语法的准确性方面，可以进行具有针对性的语法训练，比如高中语法题目等。',
          '在进行写作练习之后，一定要认真查找其中的语法错误，并修改。'
        ],
      },
      '词汇丰富度': {
        comment: [
          '根据测试结果，你最需要提升的写作能力是词汇丰富度；',
          '这项能力是指：能否熟练运用正确合理且不重复的词汇和短语，来进行写作。',
          '词汇丰富度不够通常会导致写作中反复出现同样的一个词或者几个词，导致信息传递不够丰富，甚至不够准确。'
        ],
        suggest: [
          '积累不同写作话题中的相关词汇、短语等，并将这些素材运用到自己平时的写作练习中，同时有意识的去整理和积累同义词表达，从而避免在写作中频繁使用某一个词的情况。'
        ],
      },
      '句式多样性': {
        comment: [
          '根据测试结果，你最需要提升的写作能力是句式多样性；',
          '这项能力是指：能否正确，适当得使用不同的句型结构，例如，简单句、并列句、各类从句以及虚拟、倒装等；',
          '如果该项能力较弱，会导致文章句式单一，可读性差，从而影响写作分数。'
        ],
        suggest: [
          '注重语法能力的夯实和提升，尤其注重种句型结构的积累和练习。',
          '可以利用雅思写作真题范文，学习范文中不同句型结构的使用，并进行仿写练习。'
        ],
      },
      '论点展开': {
        comment: [
          '根据测试结果，你最需要提升的写作能力是论点展开；',
          '这项能力是指：在议论文正文部分，能否根据论点，进行有逻辑地展开论证；',
          '如果该项能力较弱，通常会导致论点论据混淆，论据毫无说服力，或者毫无逻辑，从而影响写作分数。'
        ],
        suggest: [
          '了解雅思写作中的高频论点，并且熟练掌握论点展开的常见方法，如例证，因果，对比等；',
          '针对不同的论点展开方法，进行仿写练习，并对照范文进行修改，不断学习范文中良好的论点展开方式和组织语言的方式。'
        ],
      },
      '比较与对比': {
        comment: [
          '根据测试结果，你最需要提升的写作能力是比较与对比；',
          '这项能力是指：在写作中能否熟练使用比较级、最高级、倍数分数等表达来描述数据之间的关系；',
          '如果这项能力较弱，很可能会导致在雅思图表类作文中，无法准确的对图表信息进行描述，或者是描述时夹杂较多语法错误，这将直接影响写作分数。'
        ],
        suggest: [
          '可以针对性得去积累一些相关句型结构，比如，如何描述某个数值在短时间内迅速增长，翻了三倍等；',
         ' 并利用这些句型结构进行仿写练习。'
        ],
      }
    }
  }
}

export const toeflLabels = {
  reading: [
    {
      name: '句子信息理解',
    },
    {
      name: '细节事实理解',
    },
    {
      name: '段落主旨与层次分析',
    },
    {
      name: '隐含信息推断',
    },
    {
      name: '段间结构分析',
    },
    {
      name: '概要与分类信息',
    },
    {
      name: '语境中的词汇',
    },
    {
      name: '指代关系',
    },
  ],
  listening:  [
    {
      name: '细节与事实把握',
    },
    {
      name: '主旨信息把握',
    },
    {
      name: '推断能力题',
    },
    {
      name: '结构分析',
    },
    {
      name: '说话者态度识别',
    },
    {
      name: '重听题',
    },
  ],
  speaking: [
    {
      name: '流利与连贯',
    },
    {
      name: '话题发展',
    },
    {
      name: '语言使用',
    },
    {
      name: '阅读与听力语料分析',
    }
  ],
  writing: [
    {
      name: '篇章结构',
    },
    {
      name: '主题把握',
    },
    {
      name: '论证展开',
    },
    {
      name: '语法准确性',
    },
    {
      name: '阅读与听力语料分析',
    },
    {
      name: '细节转述',
    },
    {
      name: '句式多样性',
    },
    {
      name: '词汇丰富度',
    },
  ]
}

export const ieltsLabels = {
  reading: [
    {
      name: '细节信息把握',
    },
    {
      name: '同义信息转换',
    },
    {
      name: '主旨把握',
    },
    {
      name: '句子分析',
    },
    {
      name: '信息定位',
    }
  ],
  listening:  [
    {
      name: '细节信息判断',
    },
    {
      name: '单词听写',
    },
    {
      name: '同义信息转换',
    },
    {
      name: '信息预测',
    },
    {
      name: '主旨信息判断',
    },
  ],
  speaking: [
    {
      name: '流利与连贯',
    },
    {
      name: '词汇多样性',
    },
    {
      name: '语法准确性',
    },
    {
      name: '发音准确度',
    }
  ],
  writing: [
    {
      name: '主题把握',
    },
    {
      name: '语法准确性',
    },
    {
      name: '词汇丰富度',
    },
    {
      name: '句式多样性',
    },
    {
      name: '论点展开',
    },
    {
      name: '比较与对比',
    }
  ]
}


// WEBPACK FOOTER //
// ./src/components/report/evaluation_report/comment.js